/* eslint-disable no-barrel-files/no-barrel-files */

import { type BackendModule } from "i18next";
import { createDebugTranslationsPlugin } from "./debug.ts";

export type ViteDynamicImportBackendOptions = {
  loadPath: (ns: string, lang: string) => string | null;
};

let options: ViteDynamicImportBackendOptions = {
  loadPath: (ns, lang) => `src/locales/${ns}.${lang}.json`,
};

const backend: BackendModule<ViteDynamicImportBackendOptions> = {
  type: "backend",
  init: function (services, backendOptions, i18nextOptions) {
    options = backendOptions;
  },
  read: async function (language, namespace, callback) {
    const jsonFiles = import.meta.glob<
      Record<string, any> | { default: Record<string, any> }
    >("/src/**/*.json");

    const translationPath = options.loadPath(namespace, language);
    const key = "/" + translationPath;
    const loadTranslationsFn = jsonFiles[key];
    if (!loadTranslationsFn) {
      callback(
        new Error(
          `i18next-vite-dynamic-import-backend: error loading translations for ${namespace} namespace and ${language} language`,
        ),
        null,
      );
      return null;
    }

    loadTranslationsFn()
      .then((translations) => {
        const resources = translations?.default
          ? translations?.default
          : translations;
        callback(null, resources);
      })
      .catch((error) => {
        callback(error, null);
      });
  },
};
export default backend;

export { createDebugTranslationsPlugin };
